import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestOptions } from '../modal/RequestOptions';
import { environment } from '../../environments/environments';
import { indicador } from '../modal/Indicador';

@Injectable({
  providedIn: 'root',
})
export class MotorService {
  constructor(private http: HttpClient) {}
  private apiUrl = environment.API_URL_MOTOR;
  getVersao(): Observable<any> {
    const headers = new HttpHeaders({'Content-Type':'application/json;'});
    return this.http.get(this.apiUrl+"ss.versao"+'/getVersao');
  }

  getExecucao(nomeExecucao: string, PostosSelecionados: number[] | undefined): Observable<any> {
    const headers = new HttpHeaders({'Content-Type':'application/json;'});
    if(PostosSelecionados ==  undefined || PostosSelecionados.length ==0)
      return this.http.get(this.apiUrl+"ss.motor"+'/'+nomeExecucao);
    else{
      var Postos = "";
      PostosSelecionados.forEach(element => {
        if(Postos == "")
          Postos = ""+element;
        else
          Postos = Postos+", "+element;
      });
      return this.http.post(this.apiUrl+"ss.motor"+'/'+nomeExecucao+"?PostosSelecionados="+Postos, {withCredentials: true} );
    }
  }
}
